import type { ReactNode } from 'react'
import { Outlet, ScrollRestoration, useSearchParams } from 'react-router-dom'
import { useTrackLandingPageView } from 'src/api/db/apiAnalytics'
import { NavBar } from 'src/shared/components/navigation/NavBar'

import { AuthProvider } from '../../../hooks/authProvider'

const LandingPageViewTracker = () => {
  useTrackLandingPageView()
  return null
}

export function AppLayout({
  navbar,
  mode,
  variant = 'light',
  wrapOutlet,
}: {
  navbar?: boolean
  mode: 'admin' | 'user'
  variant?: 'light' | 'dark'
  wrapOutlet?: (outlet: ReactNode) => ReactNode
}) {
  const [searchParams] = useSearchParams()
  const noHeader = searchParams.get('noHeader') === 'true'

  // Hide navbar if noHeader query param is present, even if navbar prop is true
  const shouldShowNavbar = navbar && !noHeader

  const shell = shouldShowNavbar ? (
    <>
      <ScrollRestoration />
      <NavBar mode={mode} variant={variant}>
        <Outlet />
      </NavBar>
    </>
  ) : (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )

  return (
    <AuthProvider>
      <LandingPageViewTracker />
      {wrapOutlet ? wrapOutlet(shell) : shell}
    </AuthProvider>
  )
}
